import { sosHttpInstance } from './httpClient';
import {
  RESOURCE_ENDPOINTS,
  buildFilterDataEndpoint,
} from '@/constants/apiEndpoints';

// SOS: Fetch all RESOURCE_ALL_INFO
export const getAllResourceInfo1Api = async () => {
  const response = await sosHttpInstance.get(RESOURCE_ENDPOINTS.ALL_INFO);
  return response;
};

export const sosResourceListApi = async (body) => {
  const response = await sosHttpInstance.post(
    RESOURCE_ENDPOINTS.LIST + '?page=' + body.page + '&size=100',
    body,
  );
  return response.data.cardData;
};

export const resourceSummary2Api = async (resourceId, body) => {
  const response = await sosHttpInstance.post(
    RESOURCE_ENDPOINTS.DETAILS_V2 + resourceId,
    body,
  );

  return response.data;
};

export const resourceSummaryApi = async (resourceId) => {
  const response = await sosHttpInstance.get(
    RESOURCE_ENDPOINTS.DETAILS + resourceId,
  );

  return response.data;
};

export const fetchResourceFiltersApi = async () => {
  const response = await sosHttpInstance.get(
    buildFilterDataEndpoint('resource'),
  );
  return response.data.RESOURCE_PAGE;
};
